import { createAsyncThunk } from "@reduxjs/toolkit";
import { createPayment, getPaymentStatus, getPriceApparat} from "../services/paymentsServices";

export const createPaymentAction = createAsyncThunk(
    "payments/createPayment",
    async (paymentData, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("access_token");
            const deviceToken = localStorage.getItem("deviceToken");
            
            const data = await createPayment(paymentData, token, deviceToken);
            
            return data;
        } catch (error) {
            if (error.response?.status === 401) {
                return rejectWithValue(
                    "Unauthorized: Пожалуйста, войдите снова"
                );
            }
            return rejectWithValue(
                error.response?.data || "Ошибка создания платежа"
            );
        }
    }
);


// Опрос PaymentPage.jsx, пока платёж не завершён — не через createAsyncThunk
// pending/rejected в общем виде (те гасят страницу лоадером/тостом ошибки,
// см. loadingPayment в reducer'е), а тихо: сетевой сбой одного опроса — не
// повод перекрашивать весь экран, следующий тик (3с) всё равно попробует снова.
export const fetchPaymentStatus = createAsyncThunk(
    "payments/fetchPaymentStatus",
    async ({ orderId, provider }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("access_token");
            const deviceToken = localStorage.getItem("deviceToken");
            return await getPaymentStatus(orderId, provider, token, deviceToken);
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Ошибка получения статуса платежа"
            );
        }
    }
);

export const fetchPriceApparat = createAsyncThunk(
    "payments/fetchPriceApparat",
    async (_, { rejectWithValue }) => {
        try {
            const deviceToken = localStorage.getItem("deviceToken");
            const data = await getPriceApparat(deviceToken);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Ошибка загрузки цены аппарата"
            );
        }
    }
);